import { Component, computed } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { VehicleLinkCardComponent } from 'app/modules/admin/vehicles/components/vehicle-link-card/vehicle-link-card.component';
import { ExpiresAtPillComponent } from 'app/shared/components/expires-at-pill/expires-at-pill.component';
import { BaseSummarySectionComponent } from '../../../../../../shared/base-classes/sections/base-summary-section.component';
import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { VehicleRoadTaxRecordModel } from '../../../models/vehicle-road-tax-record.model';
import { DateRangePillComponent } from 'app/shared/components/date-range-pill/date-range-pill.component';
import { SummaryItemComponent } from 'shared/components/summary-item/summary-item.component';

@Component({
	selector: 'app-vehicle-road-taxes-summary',
	templateUrl: 'vehicle-road-taxes-summary.component.html',
	imports: [
		ReactiveFormsModule,
		SectionWrapperComponent,
		VehicleLinkCardComponent,
		ExpiresAtPillComponent,
		DateRangePillComponent,
		SummaryItemComponent,
	],
})
export class VehicleRoadTaxesSummaryComponent extends BaseSummarySectionComponent<VehicleRoadTaxRecordModel> {
	protected _skipCount: number = 0;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			tags: [null],
		});
	}

	isoDateFrom = computed(() =>
		new Date(this.recordData().startsAt).toISOString(),
	);
	isoDateTo = computed(() => new Date(this.recordData().endsAt).toISOString());

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			tags: this.recordData().tags,
		};
		this.detailsForm.setValue(detailsFormData);
	}

	protected _mapFormToModel(): Partial<VehicleRoadTaxRecordModel> {
		return {
			tags: this.detailsForm.value.tags,
		};
	}
}
